import { type NavigationAction } from './navigation.action';
import { setHasNavigatedToHome } from './navigation.actionCreators';
import { type NavigationState } from './navigation.state';

const initialState: NavigationState = {
  hasNavigatedToHome: false,
};

export const navigationReducer = (state = initialState, action: NavigationAction): NavigationState => {
  if (setHasNavigatedToHome.match(action)) {
    return {
      ...state,
      hasNavigatedToHome: action.payload.hasNavigated,
    };
  }

  return state;
};
